import React from "react";
import { NavLink } from "react-router-dom";

const Navbar = () => {
  return (
    <nav
      className="navbar navbar-expand-lg navbar-light"
      style={{
        backgroundColor: "#000000", // Set background color to black
        border: "1px solid black", // Add border to separate the navbar (optional if you want to see a border in black box)
        padding: "0.5rem 1rem", // Add some padding
      }}
    >
      <div className="container-fluid">
        <a
          className="navbar-brand nav-link-item head-name"
          href=""
          style={{
            color: "white", // Set brand color to white
            fontFamily: "Times New Roman",
            fontSize: "2rem",
            fontWeight: "bold",
            marginLeft: "0", // Shift to the left
          }}
        >
          FlowBench
        </a>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
            <li className="nav-item nav-link-item">
              <NavLink
                className="nav-link"
                activeClassName="active-nav"
                to="/problems"
                style={{
                  color: "white", // Set nav link color to white
                  marginRight: "15px", // Add space between buttons
                }}
              >
                Datasets
              </NavLink>
            </li>
            <li className="nav-item nav-link-item">
              <NavLink
                className="nav-link"
                activeClassName="active-nav"
                to="/geometries"
                style={{
                  color: "white", // Set nav link color to white
                  marginRight: "15px", // Add space between buttons
                }}
              >
                Geometries
              </NavLink>
            </li>
            <li className="nav-item nav-link-item">
              <NavLink
                className="nav-link"
                activeClassName="active-nav"
                to="/cfdsimulation"
                style={{
                  color: "white", // Set nav link color to white
                  marginRight: "15px",
                }}
              >
                CFD Simulations
              </NavLink>
            </li>
            <li className="nav-item nav-link-item">
              <NavLink
                className="nav-link"
                activeClassName="active-nav"
                to="/experimentalresults"
                style={{
                  color: "white", // Set nav link color to white
                  marginRight: "15px",
                }}
              >
                Experimental Results
              </NavLink>
            </li>
            <li className="nav-item nav-link-item">
              <NavLink
                className="nav-link"
                activeClassName="active-nav"
                to="/team"
                style={{
                  color: "white", // Set nav link color to white
                }}
              >
                Team
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
